<template>
   <b-navbar variant="transparent" class="container">
      <b-navbar-brand :to="{name: 'Home'}" v-if="sidebar === SidebarStates.HIDDEN">
         <img src="@/assets/img/logo/logo-dark.svg" alt="Onboard.tax®" />
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto d-flex align-items-center text-secondary text-small">
         <b-link id="nav-logout" @click="logout">Logout</b-link>
         <div class="separator"></div>
         <b-avatar
            id="nav-profile"
            :to="{name: 'profile'}"
            variant="white"
            size="2rem"
            :badge="profileBadge"
            badge-variant="danger"
         >
            <img v-auth-src="profileImageUrl" style="width: 100%; color: #1660a9" />
         </b-avatar>
         <div class="separator"></div>
         <b-link
            v-if="messagingCollapsed"
            id="nav-messaging"
            class="messaging-opener"
            @click="toggleMessaging"
         >
            <span v-if="anyUnreadMessages" class="badge badge-danger">New</span>
            <b-icon-question class="fg"></b-icon-question>
            <b-icon-chat-right-fill class="bg"></b-icon-chat-right-fill>
         </b-link>
      </b-navbar-nav>
   </b-navbar>
</template>

<script>
import {mapGetters} from 'vuex';
import {SidebarStates} from '@/store/modules/session';

export default {
   data() {
      return {
         SidebarStates,
      };
   },

   computed: {
      ...mapGetters({
         profile: 'profile',
         profileImageUrl: 'profileImageUrl',
         sidebar: 'sidebar',
         messagingCollapsed: 'messaging/clientMessagingCollapsed',
         anyUnreadMessages: 'messaging/anyUnreadMessages',
         isProfileQuestionnaireComplete: 'progress/isProfileQuestionnaireComplete',
      }),

      profileBadge() {
         return !this.isProfileQuestionnaireComplete;
      },
   },

   methods: {
      toggleMessaging() {
         this.$store.commit('messaging/toggleClientMessagingCollapsed');
      },
   },
};
</script>

<style lang="scss" scoped>
$icon-fg-collapsed-color: $gray-100;
$icon-bg-collapsed-color: #1660a9;

.container {
   padding: 1.375rem 4rem 0.75rem 2rem;

   @media (max-width: 992px) {
      margin-right: 0;
   }
}

.separator {
   background-color: $gray-600;
   border-radius: 2px;
   height: 26px;
   width: 2px;
   margin-left: 1rem;
   margin-right: 1rem;
}

.messaging-opener {
   position: fixed;
   margin-left: 140px;
   z-index: 9999;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 4rem;
   height: 4rem;
   flex: 0 0 auto;
   text-decoration: none;

   .fg {
      height: 1.1rem;
      width: 1.1rem;
      position: absolute;
      top: 1.45rem;
      left: 0.9rem;
      color: $icon-fg-collapsed-color;
      z-index: 1;
   }

   .bg {
      height: 2rem;
      width: 2rem;
      position: absolute;
      top: 1.21rem;
      left: 0.41rem;
      color: $icon-bg-collapsed-color;
      z-index: 0;
   }

   .badge {
      z-index: 2;
      position: absolute;
      bottom: 0.75rem;
      right: -0.1rem;
   }
}

@media (max-width: 1159px) {
   .messaging-opener {
      display: none !important;
   }
}
</style>
